module.exports = __webpack_public_path__ + "static/media/booking-border.0256bdc9.png";